export var SystemTagType;
(function (SystemTagType) {
    SystemTagType["ESCALATED"] = "escalated";
})(SystemTagType || (SystemTagType = {}));
/** Hex color format accepted for invoice tag colors */
export const TAG_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;
//# sourceMappingURL=tag.js.map